// extracted by mini-css-extract-plugin
var _1 = "LoginForm-modulelicense__enSDn AuthLicense-moduleAuthLicense__m52dv";
var _2 = "LoginForm-moduleloginAsEmployeeButton__qYkTk";
var _3 = "LoginForm-moduletab__Ge825 Tab-moduleTab__yRe6s";
var _4 = "LoginForm-moduletabList__wSMkr TabList-moduleTabList__ioZlK";
var _5 = "LoginForm-moduletitle__NVhAP AuthTitle-moduleAuthTitle__VKaTa";
var _6 = "LoginForm-modulewithNotifications__DUfNQ";
export { _1 as "license", _2 as "loginAsEmployeeButton", _3 as "tab", _4 as "tabList", _5 as "title", _6 as "withNotifications" }
